export default
`
Biofilms are communities of microorganisms (an organism that can only be seen through a microscope) attached to surfaces. They are found in many places within nature, but in the human body biofilms can be the plaque that form on your teeth causing tooth decay, and part of the microbiome (the community of microorganisms that reside in the human body). \r\n

Biofilms can be described as a city of microbes, which is what this piece depicts. 

`


// WEBPACK FOOTER //
// ./src/content/biofilms.js